"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onSelectResultHandler = exports.onInputClickHandler = exports.onKeyDownHandler = exports.onKeyUpHandler = exports.onChangeHandler = void 0;
var _mergeInputField = require("./mergeInputField.helper");
var _mergeInputField2 = require("./mergeInputField.data");
var _dropdownContainer = require("./dropdownContainer/dropdownContainer.helper");
var _mergeLookupField = require("./mergeLookupField.helper");
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  }
}
var promotionType = _mergeInputField2.dataTypes.promotionType,
  promotionFieldType = _mergeInputField2.dataTypes.promotionFieldType,
  lookupType = _mergeInputField2.dataTypes.lookupType,
  lookupFieldType = _mergeInputField2.dataTypes.lookupFieldType;
var onSelectResultHandler = function onSelectResultHandler(value, parameters) {
  return function (id) {
    var isMerging = parameters.isMerging,
      cursorPosition = parameters.cursorPosition,
      highlightedItem = parameters.highlightedItem,
      onSelect = parameters.onSelect,
      onUpdateValue = parameters.onUpdateValue,
      selectedItem = parameters.selectedItem,
      onUpdateFilter = parameters.onUpdateFilter,
      onClearHighlight = parameters.onClearHighlight,
      onMerging = parameters.onMerging,
      isPaginated = parameters.isPaginated,
      onResetPaging = parameters.onResetPaging,
      types = parameters.types;
    if ((0, _mergeInputField.shouldConvertFirstToMergeField)({
      value: value,
      highlightedItem: highlightedItem,
      types: types
    })) {
      (0, _mergeInputField.convertFirstToMergeField)({
        value: value,
        id: id,
        selectedItem: selectedItem,
        highlightedItem: highlightedItem,
        cursorPosition: cursorPosition,
        onUpdateValue: onUpdateValue,
        onSelect: onSelect,
        onUpdateFilter: onUpdateFilter,
        onClearHighlight: onClearHighlight,
        isPaginated: isPaginated,
        onResetPaging: onResetPaging
      });
      return;
    }
    if (isMerging) {
      if (highlightedItem.sourceType === lookupType) {
        var newValue = (0, _mergeInputField.replaceWordAt)(value, cursorPosition, (0, _mergeInputField.convertToMergeField)("".concat(highlightedItem.title, ".")));
        onUpdateValue(id, newValue);
        onSelect(id, highlightedItem);
      } else if (highlightedItem.sourceType === lookupFieldType) {
        onUpdateValue(id, (0, _mergeLookupField.mergeLookupField)({
          value: value,
          cursorPosition: cursorPosition,
          highlightedItem: highlightedItem
        }));
        onSelect(id, highlightedItem);
      } else {
        var _newValue = (0, _mergeInputField.replaceWordAt)(value, cursorPosition, (0, _mergeInputField.convertToMergeField)(highlightedItem.title));
        onSelect(id, null);
        onUpdateValue(id, _newValue);
        onMerging(id, false);
      }
    } else {
      var _newValue2 = "".concat(highlightedItem.title).concat([promotionType, lookupType].includes(highlightedItem.sourceType) ? _mergeInputField2.parentChildDelimiter : '');
      if ([promotionFieldType, lookupFieldType].includes(highlightedItem.sourceType)) {
        onUpdateValue(id, "".concat(selectedItem.title, ".").concat(highlightedItem.title));
      } else {
        onUpdateValue(id, _newValue2);
      }
      onSelect(id, highlightedItem);
    }
    onUpdateFilter(id, '');
    onClearHighlight(id);
    isPaginated && onResetPaging(id);
  };
};
exports.onSelectResultHandler = onSelectResultHandler;
var onMergeTriggerHandler = function onMergeTriggerHandler(value, currentCursorPosition, parameters) {
  return function (id) {
    var onMerging = parameters.onMerging,
      onUpdateFilter = parameters.onUpdateFilter,
      isPromotionSelected = parameters.isPromotionSelected,
      isLookupSelected = parameters.isLookupSelected,
      isLookupFieldSelected = parameters.isLookupFieldSelected,
      selectedItem = parameters.selectedItem,
      isMergingAllowed = parameters.isMergingAllowed;
    var wordAtCursor = (0, _mergeInputField.getWordAt)(value, currentCursorPosition);
    var mergeTriggerSymbol = [].concat(_toConsumableArray(_mergeInputField2.mergeTriggerSymbols.map(function (symbol) {
      return "".concat(symbol, "{");
    })), _toConsumableArray(_mergeInputField2.mergeTriggerSymbols)).find(function (symbol) {
      return wordAtCursor.startsWith(symbol);
    });
    if (!isLookupSelected && isMergingAllowed && mergeTriggerSymbol) {
      onMerging(id, true);
      onUpdateFilter(id, wordAtCursor.substr(mergeTriggerSymbol.length));
    } else if (isPromotionSelected) {
      onMerging(id, false);
      onUpdateFilter(id, value.substr(selectedItem.title.length + 1));
    } else if (isLookupSelected || isLookupFieldSelected) {
      var isMerging = (0, _mergeLookupField.isMergingLookupField)({
        value: value,
        currentCursorPosition: currentCursorPosition,
        isLookupFieldSelected: isLookupFieldSelected
      });
      onMerging(id, isMergingAllowed && isMerging);
      onUpdateFilter(id, (0, _mergeLookupField.getLookupMergeFieldFilter)({
        isMerging: isMerging,
        value: value,
        currentCursorPosition: currentCursorPosition,
        selectedItem: selectedItem
      }));
    } else {
      onMerging(id, false);
      onUpdateFilter(id, value);
    }
  };
};
var onChangeHandler = function onChangeHandler(_ref, parameters) {
  var target = _ref.target;
  return function (id) {
    var inputValue = target.value,
      currentCursorPosition = target.selectionStart;
    var onUpdateValue = parameters.onUpdateValue,
      selectedItem = parameters.selectedItem,
      isMerging = parameters.isMerging,
      isPromotionSelected = parameters.isPromotionSelected,
      isLookupSelected = parameters.isLookupSelected,
      isLookupFieldSelected = parameters.isLookupFieldSelected,
      onUpdateFilter = parameters.onUpdateFilter,
      onSelect = parameters.onSelect,
      onClearHighlight = parameters.onClearHighlight,
      isMergingAllowed = parameters.isMergingAllowed;
    onUpdateValue(id, inputValue);
    if (!isMerging && !isPromotionSelected) {
      onUpdateFilter(id, inputValue);
      onSelect(id, null);
    }
    if (isPromotionSelected) {
      if (!inputValue.startsWith("".concat(selectedItem.title).concat(_mergeInputField2.parentChildDelimiter))) {
        onSelect(id, null);
      }
    } else if (isLookupSelected) {
      if (isLookupFieldSelected || selectedItem.fields.length === 0) {
        onSelect(id, null);
      }
    } else {
      if (isMergingAllowed && selectedItem) {
        (0, _mergeInputField.doDefaultMerging)({
          selectedItem: selectedItem,
          inputValue: inputValue,
          currentCursorPosition: currentCursorPosition,
          onUpdateValue: onUpdateValue,
          id: id
        });
      }
      onSelect(id, null);
    }
    onClearHighlight(id);
  };
};
exports.onChangeHandler = onChangeHandler;
var onUserInteractionEndHandler = function onUserInteractionEndHandler(_ref2, parameters) {
  var target = _ref2.target;
  return function (id) {
    var onChangeCursorPosition = parameters.onChangeCursorPosition;
    var inputValue = target.value,
      currentCursorPosition = target.selectionStart;
    onChangeCursorPosition(id, currentCursorPosition);
    onMergeTriggerHandler(inputValue, currentCursorPosition, parameters)(id);
  };
};
var onInputClickHandler = function onInputClickHandler(_ref3, parameters) {
  var target = _ref3.target;
  return function (id) {
    return onUserInteractionEndHandler({
      target: target
    }, parameters)(id);
  };
};
exports.onInputClickHandler = onInputClickHandler;
var onKeyUpHandler = function onKeyUpHandler(_ref4, parameters) {
  var target = _ref4.target;
  return function (id) {
    return onUserInteractionEndHandler({
      target: target
    }, parameters)(id);
  };
};
exports.onKeyUpHandler = onKeyUpHandler;
var onChangeHighlightHandler = function onChangeHighlightHandler(_ref5) {
  var isDirectionDown = _ref5.isDirectionDown,
    onMoveDown = _ref5.onMoveDown,
    onMoveUp = _ref5.onMoveUp,
    highlightedIndex = _ref5.highlightedIndex,
    step = _ref5.step,
    results = _ref5.results,
    onHighlightByIndex = _ref5.onHighlightByIndex;
  return function (id) {
    if (isDirectionDown) {
      // eslint-disable-next-line no-unused-expressions
      highlightedIndex === null || highlightedIndex < results.length - step ? onMoveDown(id) : onHighlightByIndex(id, results.length - 1);
    } else {
      // eslint-disable-next-line no-unused-expressions
      highlightedIndex > step - 1 ? onMoveUp(id) : onHighlightByIndex(id, 0);
    }
  };
};
var onScrollUpdateHandler = function onScrollUpdateHandler(_ref6) {
  var isDirectionDown = _ref6.isDirectionDown,
    pivotReferences = _ref6.pivotReferences;
  var highlightRef = pivotReferences[isDirectionDown ? 'down' : 'up'];
  (0, _dropdownContainer.scrollTo)({
    highlightRef: highlightRef
  });
};
var onMovementKeysHandler = function onMovementKeysHandler(_ref7) {
  var results = _ref7.results,
    event = _ref7.event,
    key = _ref7.key,
    highlightedIndex = _ref7.highlightedIndex,
    onHighlightNext = _ref7.onHighlightNext,
    onHighlightPrevious = _ref7.onHighlightPrevious,
    onHighlightNextPage = _ref7.onHighlightNextPage,
    onHighlightPrevPage = _ref7.onHighlightPrevPage,
    pivotReferences = _ref7.pivotReferences,
    pageSize = _ref7.pageSize,
    onLoadNextPage = _ref7.onLoadNextPage,
    onHighlightByIndex = _ref7.onHighlightByIndex;
  return function (id) {
    if (results.length > 0) {
      event.preventDefault();
    }
    var isDirectionDown = ['ArrowDown', 'PageDown'].includes(key);
    var isJumpingOverPage = ['PageDown', 'PageUp'].includes(key);
    onChangeHighlightHandler({
      highlightedIndex: highlightedIndex,
      results: results,
      pageSize: pageSize,
      isDirectionDown: isDirectionDown,
      onLoadNextPage: onLoadNextPage,
      onHighlightByIndex: onHighlightByIndex,
      step: isJumpingOverPage ? Math.floor(pageSize / 2) : 1,
      onMoveDown: isJumpingOverPage ? onHighlightNextPage : onHighlightNext,
      onMoveUp: isJumpingOverPage ? onHighlightPrevPage : onHighlightPrevious
    })(id);
    onScrollUpdateHandler({
      isDirectionDown: isDirectionDown,
      pivotReferences: pivotReferences[isJumpingOverPage ? 'page' : 'arrow']
    });
  };
};
var onKeyDownHandler = function onKeyDownHandler(event, parameters) {
  return function (id) {
    var areResultsVisible = parameters.areResultsVisible,
      results = parameters.results,
      highlightedIndex = parameters.highlightedIndex,
      onHighlightNext = parameters.onHighlightNext,
      onHighlightPrevious = parameters.onHighlightPrevious,
      isMerging = parameters.isMerging,
      cursorPosition = parameters.cursorPosition,
      highlightedItem = parameters.highlightedItem,
      onSelect = parameters.onSelect,
      onUpdateValue = parameters.onUpdateValue,
      selectedItem = parameters.selectedItem,
      onUpdateFilter = parameters.onUpdateFilter,
      onClearHighlight = parameters.onClearHighlight,
      onMerging = parameters.onMerging,
      onResetPaging = parameters.onResetPaging,
      pageSize = parameters.pageSize,
      pivotReferences = parameters.pivotReferences,
      onHighlightNextPage = parameters.onHighlightNextPage,
      onHighlightPrevPage = parameters.onHighlightPrevPage,
      onLoadNextPage = parameters.onLoadNextPage,
      onHighlightByIndex = parameters.onHighlightByIndex,
      types = parameters.types;
    if (areResultsVisible) {
      var key = event.key;
      if (['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp'].includes(key)) {
        onMovementKeysHandler({
          results: results,
          event: event,
          key: key,
          highlightedIndex: highlightedIndex,
          onHighlightNext: onHighlightNext,
          onHighlightPrevious: onHighlightPrevious,
          onHighlightNextPage: onHighlightNextPage,
          onHighlightPrevPage: onHighlightPrevPage,
          pivotReferences: pivotReferences,
          pageSize: pageSize,
          onLoadNextPage: onLoadNextPage,
          onHighlightByIndex: onHighlightByIndex
        })(id);
      } else if (key === 'Enter') {
        if (highlightedIndex !== null) {
          event.preventDefault();
          onSelectResultHandler(event.target.value, {
            isMerging: isMerging,
            cursorPosition: cursorPosition,
            highlightedItem: highlightedItem,
            onSelect: onSelect,
            onUpdateValue: onUpdateValue,
            selectedItem: selectedItem,
            onUpdateFilter: onUpdateFilter,
            onClearHighlight: onClearHighlight,
            onMerging: onMerging,
            onResetPaging: onResetPaging,
            types: types
          })(id);
        }
      }
    }
  };
};
exports.onKeyDownHandler = onKeyDownHandler;